module.exports = __webpack_public_path__ + "media/images/globet-96925a8e8007d85a104c767902519862.png";